<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import BaseDialog from "@/stories/dialogs/BaseDialog.vue";
import Button from "@/stories/buttons/Button/Button.vue";
import emitter, { type EventUnsavedChangesParams } from "@/emitter";

const data = ref<EventUnsavedChangesParams>();

const onMessage = (params: EventUnsavedChangesParams) => {
  data.value = params;
};

const handleClose = () => {
  data.value = undefined;
};

const handleConfirm = () => {
  if (data.value) {
    data.value.onConfirm();
  }

  data.value = undefined;
};

onMounted(() => {
  emitter.on("showUnsavedChanges", onMessage);
});

onBeforeUnmount(() => {
  emitter.off("showUnsavedChanges", onMessage);
});
</script>

<template>
  <BaseDialog v-if="!!data" @on-close="handleClose">
    <div
      class="overflow-hidden w-full text-center place-items-center laptop:w-[28.125rem] pt-12 pb-8 px-4"
    >
      <div class="relative h800 text-neutral1000 px-8">
        <div class="flex items-center justify-center">
          {{ $t("global.unsavedChanges") }}
        </div>
      </div>
      <div class="b300 py-3 text-center">
        {{ $t("global.unsavedChangesDescription") }}
      </div>
    </div>
    <div class="flex justify-between gap-3 py-4 px-6">
      <Button
        type="grey"
        fullWidth
        :text="$t('templates.cancel')"
        @click="handleClose"
      />
      <Button
        type="error"
        fullWidth
        :text="$t('global.unsavedChangesConfirmYes')"
        @click="handleConfirm"
      />
    </div>
  </BaseDialog>
</template>
